import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { Dictionary, OfferDetails, Settings, User, OfferDocument } from '../../models/models';
import { HeaderService } from '../../services/header.service';
import { DictionaryService } from '../../services/dictionary.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalInfoComponent } from '../../sections/modal-info/modal-info.component';
import { ModalSetStatusComponent } from '../../sections/modal-set-status/modal-set-status.component';
import { OfferService } from '../../services/offer.service';
import { ModalErrorComponent } from '../../sections/modal-error/modal-error.component';
import { EventEmitterService } from '../../services/event-emitter.service';
import { AuthGuard } from '../../services/auth/auth.guard';
import { UtilsService } from '../../services/helpers/utils.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
})
export class OfferComponent implements OnInit {
  offer: OfferDetails;
  offerSaveError: string;
  noStatusError: string;
  activeTab = 1;
  allowTypeEdit: boolean = false;
  allowUserEdit: boolean = false;

  settings: Settings;

  draftText: string;
  blockedText: string;

  constructor(
    private title: Title,
    private translate: TranslateService,
    private headerService: HeaderService,
    private dictionaryService: DictionaryService,
    private eventEmitterService: EventEmitterService,
    private offerService: OfferService,
    private utilsService: UtilsService,
    private authGuard: AuthGuard,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private router: Router,
  ) { }

  ngOnInit() {
    this.translate.get('Pages.Offer').subscribe((res: any) => {
      this.title.setTitle(res.Title);
      this.offerSaveError = res.OfferSaveError;
      this.noStatusError = res.NoStatusError;
      this.draftText = res.DraftText;
      this.blockedText = res.BlockedText;
      this.headerService.setPageTitle(false, 0, res.Title);

      this.offer = this.route.snapshot.data.offer;
      if (!this.offer || this.offer.id == 0) {
        this.router.navigate(['/not-found']);
      }
      else {
        this.allowTypeEdit = (environment.offerTypes as Dictionary[]).filter(x => x.value == this.offer.typeId).length > 0;
        this.allowUserEdit = this.offer.members.find((x: User) => x.id === this.authGuard.userId)?.isAuthor;
      }
    });

    this.dictionaryService.getSettings()
      .subscribe((settings: Settings) => {
        this.settings = settings;
      });
  }

  changeStatus() {
    this.dictionaryService.getAvailableStatuses(this.offer.statusId, this.offer.routeId).subscribe((res) => {
      const modalRef = this.modalService.open(ModalSetStatusComponent);
      modalRef.componentInstance.statuses = res;
      modalRef.componentInstance.statusName = this.offer.statusName;
      modalRef.componentInstance.noStatusError = this.noStatusError;

      modalRef.componentInstance.passEntry.subscribe((res: any) => {
        this.offerService
          .saveStatus(this.offer.id, this.authGuard.userId, res.statusId)
          .subscribe((result) => {
            if (result.result) {
              this.offer.statusId = res.statusId;
              this.offer.statusName = res.statusName;
              this.eventEmitterService.onChangeOfferStatus(this.offer.statusId);
            } else {
              const modalRef = this.modalService.open(ModalErrorComponent);
              modalRef.componentInstance.errors = [this.offerSaveError];
            }
          });
      });
    });
  }

  public offerDocumentAsDataUrl(offerDocument: OfferDocument): string {
    if (offerDocument.fileContentType && offerDocument.fileContent) {
      return `data:${offerDocument.fileContentType};base64,${offerDocument.fileContent}`;
    }
    else if (offerDocument.thumbnailUrl) {
      return `${offerDocument.thumbnailUrl}`;
    }
    return '';
  }

  public downloadOfferDocument(offerDocument: OfferDocument) {
    if (offerDocument.fileContentType && offerDocument.fileContent) {
      const theFile = this.utilsService.b64toBlob(offerDocument.fileContent, offerDocument.fileContentType, 512);
      const url = window.URL.createObjectURL(theFile);
      window.open(url);
    }
    else if (offerDocument.fileUrl) {
      window.open(offerDocument.fileUrl, "_blank");
    }
    else if (offerDocument.thumbnailUrl) {
      window.open(offerDocument.thumbnailUrl, "_blank");
    }
  }

  editOffer() {
    if (this.allowTypeEdit) {
      this.router.navigate(["/add-offer/" + this.offer.id]);
    }
    else {
      this.translate.get('Pages.Offer').subscribe((res: any) => {
        const modalRef = this.openModalWindow(ModalInfoComponent);
        modalRef.componentInstance.header = '';
        modalRef.componentInstance.text = res.EditOfferErrorText1 + this.offer.typeName + res.EditOfferErrorText2;
      });
    }
  }

  openModalWindow(content: any) {
    const modalRef = this.modalService.open(content, { windowClass: 'custom-position-modal' });
    return modalRef;
  }

  isThereAnAuthor = (val: User[], author: string): boolean => {
    if (author === 'isAuthor') {
      return val.some((x) => x.isAuthor);
    }
    return val.some((x) => x.isCoAuthor);
  };
}
